import { DEFAULT_ALLOWED_DEVICE_CODE_LENGTH, DEVICE_CODE_POSSIBLE_LENGTH } from "../../constants";
export const removeSpacesFromCode = (deviceCode) => deviceCode.replace(/\s/g, "");
const formatDeviceCode = (deviceCode, joinSymbol, isGen4DeviceCode) => {
    var _a, _b;
    const codeGroupSize = isGen4DeviceCode ? 5 : 4;
    const codePattern = new RegExp(`.{1,${codeGroupSize}}`, "g");
    return (_b = (_a = deviceCode.match(codePattern)) === null || _a === void 0 ? void 0 : _a.join(joinSymbol)) !== null && _b !== void 0 ? _b : "";
};
export const registrationCodeFormatter = (deviceCode, joinSymbol = " ", allowedLength = DEFAULT_ALLOWED_DEVICE_CODE_LENGTH) => {
    const maxDeviceCodeLength = Math.max(...allowedLength);
    const trimmedValue = removeSpacesFromCode(deviceCode).slice(0, maxDeviceCodeLength);
    const isGen4DeviceCode = allowedLength.includes(DEVICE_CODE_POSSIBLE_LENGTH.GEN4) &&
        trimmedValue.length === DEVICE_CODE_POSSIBLE_LENGTH.GEN4;
    return formatDeviceCode(trimmedValue, joinSymbol, isGen4DeviceCode);
};
//# sourceMappingURL=registrationCode.js.map